import { mapGetters } from 'vuex';
import { DEFAULT_URI } from '@/constants';

export default {
  name: 'EcsDisableControlsMixin',

  computed: {
    ...mapGetters(['theme', 'selectedBusinessProcesses']),

    disableControls() {
      const isDefaultBp = this.selectedBusinessProcesses.some(bp => bp.uri === DEFAULT_URI);
      const isEnableCustomTheme = this.theme.overrideDefaultTheme;

      if (isDefaultBp) {
        return false;
      }

      return !isEnableCustomTheme;
    }
  }
};
